import { UiSchema } from 'prove-common/rjsf'

export const moveSampleUiSchema: UiSchema = {
  'ui:classNames': 'max-w-[832px]',
  'ui:options': {
    allowWrap: true
  },
  substanceIds: {
    'ui:widget': 'multiSelectWidget'
  }
}
